export enum EdiStyle {
	Basic = 0,
	SAP = 10,
	HANA = 20
}